import { useState } from 'react';

import { Text, Flex, Badge, Button, Spinner } from '@chakra-ui/react';

import { AddIcon } from '@chakra-ui/icons';

import type { APIUserListResultData } from 'types/api.types';

const AddUserButtons = ({
  user,
  hide,
  onAdd,
}: {
  user: APIUserListResultData;
  hide: boolean;
  onAdd: (user: APIUserListResultData, withNotifications: boolean) => void;
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleOnAdd = (withNotifications: boolean) => {
    onAdd(user, withNotifications);
    setIsLoading(true);
  };

  if (hide) {
    return (
      <Badge
        colorScheme="green"
        w="100%"
        textAlign="center"
        h="32px"
        alignContent="center"
      >
        Already added
      </Badge>
    );
  }

  if (isLoading) {
    return (
      <Flex gap={2} align="center" justify="center" h="32px">
        <Spinner />
        <Text>Adding...</Text>
      </Flex>
    );
  }

  return (
    <Flex gap={2} align="center">
      <Button
        size="sm"
        leftIcon={<AddIcon />}
        onClick={() => handleOnAdd(false)}
        variant="brand"
        w="100%"
      >
        Add user
      </Button>
      <Button
        size="sm"
        leftIcon={<AddIcon />}
        onClick={() => handleOnAdd(true)}
        variant="yellow"
        w="100%"
        whiteSpace="normal"
      >
        Add with notifications
      </Button>
    </Flex>
  );
};

export default AddUserButtons;
